module.exports = __webpack_public_path__ + "static/media/PACIVerfified.73cee5ad.svg";